const $ = window.$;

import Model from '../model/philosophy';

import Wave from '../utill/wave';

export default class Philosophy {

  constructor() {
    this.model = new Model;
    this.set();
    this.bindEvents();
  }



// -----------------------------------------------------------------
// 初期設定
// @method set
// -----------------------------------------------------------------
  set() {
    // .js-phiolo-contentsに高さ設定
    const _setContentsHeight = () => {
      $('.js-phiolo-contents').each((i, el) => {
        const $el = $(el);
        const bodyHeight = $el.find('.p-phiolo-contents__body').height() ? $el.find('.p-phiolo-contents__body').height() : 0;
        const imgHeight = $el.find('.p-phiolo-contents__img').height() ? $el.find('.p-phiolo-contents__img').height() : 0;
        if(bodyHeight >= imgHeight)
          $el.height(bodyHeight);
        else
          $el.height(imgHeight);
      });
    }

    // サークル生成
    const _initCircle = () => {
      $('.js-philo-circle').each((i, el) => {
        $(el).morphing({
          numVert: 10,
          spring: 0.005,
          friction: 0.9,
          radius: this.model.state.circleWidthArray[i] / 2,
          fps: 90
        });
      });
    }

    const _setHeight = () => {
      console.log('ji')
      // $('.c-hero__bg').height($('.c-hero').height())
    }

    if(!this.model.state.isSP) {
      _setContentsHeight();
    } else {
      _setHeight();
    }
    _initCircle();
    new Wave(this.model.state.isSP);
  }



// -----------------------------------------------------------------
// イベント設定
// @method bindEvents
// -----------------------------------------------------------------
  bindEvents() {
    $(window).scroll((e) => {
      this.model.changeScroll();
    });

    $('#js-philoPage').on('animation', (e, index) => {
      console.log(index)
      this.onAnimtation(index);
    });
  }



// -----------------------------------------------------------------
// アニメーション発火
// @method onAnimtation
// -----------------------------------------------------------------
  onAnimtation(index) {
    if(index === 0) {
      this.animateLeaves(index);
      this.animateDrop();
    } else {
      this.animateLeaves(index);
    }
  }



// -----------------------------------------------------------------
// 葉っぱ落下アニメーション 
// @method animateLeaves
// -----------------------------------------------------------------
  animateLeaves(index) {
    let animationData = '';
    if(index % 2 === 0) {
      animationData = { top: '100%', left: '100%'}
    } else {
      animationData = { top: '100%', right: '100%'}
    }
    
    $('.js-philo-leaves').eq(index).animate(animationData, 15000)
  }



// -----------------------------------------------------------------
// 水滴落下アニメーション 
// @method animateLeaves
// -----------------------------------------------------------------
  animateDrop() {
    $('#js-phiolo-drop').addClass('is-active');
  }
}


/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/view/philosophy.js
 **/